import { Badge } from '@/components/ui/badge.tsx';
import { ReactNode } from 'react';

type BadgeVariant = 'default' | 'secondary' | 'destructive' | 'outline';

const STATUS_VARIANTS: Record<string, BadgeVariant> = {
  proposed: 'secondary',
  partial: 'secondary',
  approved: 'default',
  succeeded: 'default',
  success: 'default',
  signed: 'default',
  completed: 'default',
  active: 'default',
  failed: 'destructive',
  critical: 'destructive',
  attention: 'secondary',
  ok: 'default',
  insufficient_data: 'secondary',
  empty: 'outline',
  rejected: 'destructive',
  draft: 'outline',
  default: 'outline',
  warning: 'secondary',
  info: 'outline',
  positive: 'default',
};

interface StatusBadgeProps {
  status: string;
  children: ReactNode;
}

export function StatusBadge({ status, children }: StatusBadgeProps) {
  const variant = STATUS_VARIANTS[status] ?? STATUS_VARIANTS.default;

  return <Badge variant={variant}>{children}</Badge>;
}
